'use strict';

angular.module('ringbaPortal.services').factory('groupByService', groupByService);

function groupByService(_, $http, $q, $log, moment, authService, ngAuthSettings, utils, accountsService) {
  'ngInject';

  const serviceBase = ngAuthSettings.apiServiceBaseUri;

  const headers = {
    calls: {
      display: 'Incoming',
      title: 'Incoming Calls',
      filter: 'number',
      hideOnSmall: false,
      align: 'right',
      search: true,
      hideFromAffiliate: false,
      hideFromBuyer: false,
      hideFromGroupings: ['targetName']
    },
    connected: {
      display: 'Connected',
      title: 'Connected Calls',
      filter: 'number',
      hideOnSmall: false,
      align: 'right',
      search: true,
      hideFromAffiliate: true,
      hideFromBuyer: false
    },

    qualified: {
      display: 'Qualified',
      displayForAffiliate: 'Converted',
      title: 'Calls Qualified for Payout',
      titleForAffiliate: 'Calls Converted',
      filter: 'number',
      hideOnSmall: false,
      align: 'right',
      search: true,
      hideFromAffiliate: false,
      hideFromBuyer: true,
      hideFromGroupings: ['targetName']
    },
    converted: {
      display: 'Converted',
      title: 'Calls Converted to Revenue',
      filter: 'number',
      hideOnSmall: false,
      align: 'right',
      search: true,
      hideFromAffiliate: true,
      hideFromBuyer: false
    },
    completed: {
      display: 'Completed',
      title: 'Completed Calls',
      filter: 'number',
      hideOnSmall: false,
      align: 'right',
      search: true,
      hideFromAffiliate: false,
      hideFromBuyer: false
    },
    noTarget: {
      display: 'No Target',
      title: 'No Target Available',
      filter: 'number',
      hideOnSmall: false,
      align: 'right',
      search: true,
      hideFromAffiliate: true,
      hideFromBuyer: true
    },
    errorCall: {
      display: 'Error',
      title: 'Error Connecting',
      filter: 'number',
      hideOnSmall: false,
      align: 'right',
      search: true,
      hideFromAffiliate: true,
      hideFromBuyer: false
    },
    noAnswer: {
      display: 'No Answer',
      title: 'No Answer',
      filter: 'number',
      hideOnSmall: false,
      align: 'right',
      search: true,
      hideFromAffiliate: true,
      hideFromBuyer: false
    },
    noConnect: {
      display: 'No Connect',
      title: 'No Targets Connected',
      filter: 'number',
      hideOnSmall: false,
      align: 'right',
      search: true,
      hideFromAffiliate: true,
      hideFromBuyer: true
    },
    blocked: {
      display: 'Blocked',
      title: 'Blocked Call',
      filter: 'number',
      hideOnSmall: false,
      align: 'right',
      search: true,
      hideFromAffiliate: true,
      hideFromBuyer: true,
      hideFromGroupings: ['targetName']
    },

    payout: {
      display: 'Payout',
      displayForAffiliate: 'Revenue',
      title: 'Payout',
      titleForAffiliate: 'Revenue',
      filter: 'currency',
      hideOnSmall: true,
      align: 'right',
      search: false,
      hideFromAffiliate: false,
      hideFromBuyer: true,
      hideFromGroupings: ['targetName'],
      filterOption: 2
    },

    amount: {
      display: 'Revenue',
      displayForBuyer: 'Payout',
      title: 'Total Conversion Amount',
      titleForBuyer: 'Payout',
      filter: 'currency',
      hideOnSmall: false,
      align: 'right',
      search: false,
      hideFromAffiliate: true,
      hideFromBuyer: false,
      filterOption: 2
    },
    profit: {
      display: 'Profit',
      title: 'Profit',
      filter: 'currency',
      hideOnSmall: true,
      align: 'right',
      search: false,
      hideFromAffiliate: true,
      hideFromBuyer: true,
      hideFromGroupings: ['numberPoolName', 'number', 'previouseCallCallId', 'targetName']
    },
    pc: {
      display: 'CR%',
      title: 'Conversion Percentage',
      filter: 'percent',
      hideOnSmall: true,
      align: 'right',
      search: false,
      hideFromAffiliate: false,
      hideFromBuyer: false,
      hideFromGroupings: ['targetName'],
      filterOption: 2
    },
    rpc: {
      display: 'RPC',
      title: 'Revenue per Call ',
      filter: 'currency',
      hideOnSmall: false,
      align: 'right',
      search: false,
      hideFromAffiliate: false,
      hideFromBuyer: true,
      hideFromGroupings: ['targetName'],
      filterOption: 2
    },
    acl: {
      display: 'ACL',
      title: 'Avg Call Length',
      filter: 'secondsDisplayFormat',
      hideOnSmall: false,
      align: 'right',
      search: false,
      hideFromAffiliate: false,
      hideFromBuyer: false
    },
    tm: {
      display: 'TCL',
      title: 'Total Call Length',
      filter: 'secondsDisplayFormat',
      hideOnSmall: true,
      align: 'right',
      search: false,
      hideFromAffiliate: false,
      hideFromBuyer: false
    },
    TC: {
      display: 'Cost',
      title: 'Total Cost',
      filter: 'currency',
      hideOnSmall: true,
      align: 'right',
      search: false,
      hideFromAffiliate: true,
      hideFromBuyer: true,
      hideFromGroupings: ['targetName'],
      filterOption: 3
    }
  };
  const nameMap = {
    'ConnectedCall': 'connected',
    'ConvertedCall': 'converted',
    'PayoutCall': 'qualified',
    'CompletedCall': 'completed',
    'NoTargetFound': 'noTarget',
    'NoTargetsAnswered': 'noConnect',
    'ErrorCall': 'errorCall',
    'NoAnswer': 'noAnswer',
    //'BusyCall':'noConnect',
    'BlockedCall': 'blocked'

  };

  let groupBysCache = 0;

  const service = {
    parseGroupData: parseGroupData,
    getAvailableGroupBys: getAvailableGroupBys,
    clearGroupBysCache: clearGroupBysCache,
    getMessageNamesFromColumns: getMessageNamesFromColumns,
    getHeaders: getHeaders,
    transformDisplayName: transformDisplayName
  };

  return service;


  function getHeaders(isAffiliate, isBuyer, groupings) {
    isAffiliate = isAffiliate || accountsService.isAffiliate();
    isBuyer = isBuyer || accountsService.isBuyer();
    const deferred = $q.defer();
    if (isAffiliate || isBuyer || groupings) {
      const newHeader = {};
      _.forEach(headers, function (value, key) {
        if (!_exclude(value,isAffiliate,isBuyer,groupings)) {
          newHeader[key] = value;
        }
      });
      deferred.resolve(newHeader);

    } else {
      deferred.resolve(headers);
    }
    return deferred.promise;
  }

  function _exclude(heading,isAffiliate,isBuyer,groupings){
    if(isAffiliate && heading.hideFromAffiliate){
      return true;
    }
    if(isBuyer && heading.hideFromBuyer){
      return true;
    }
    if(heading.hideFromGroupings && heading.hideFromGroupings.length){
      if(groupings && groupings.groupBy && groupings.groupBy.length){
        for(let i=0;i<heading.hideFromGroupings.length;i++){
          for(let j=0;j<groupings.groupBy.length;j++){
            if(heading.hideFromGroupings[i]===groupings.groupBy[j].field){
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  // TODO: Cache this across calls in localstorage maybe - it's getting hit by _getData & _fillGroupBys
  function getAvailableGroupBys(accountId, viewAsPublisherId, viewAsBuyerId) {
    const deferred = $q.defer();

    if (!groupBysCache 
      || !viewAsPublisherId && !viewAsBuyerId && !groupBysCache.admin 
      || viewAsPublisherId && !groupBysCache[viewAsPublisherId] 
      || viewAsBuyerId && !groupBysCache[viewAsBuyerId]) {
      const url = _appendBuyerAndPublisherId(serviceBase + accountId + '/callLogs/AvailableGroupBys', viewAsPublisherId, viewAsBuyerId);
      $http({ url: url }).then(function (data) {
        groupBysCache = groupBysCache || {};
        if (viewAsBuyerId) {
          groupBysCache[viewAsBuyerId] = data.data.groupBys;
        }
        else if (viewAsPublisherId) {
          groupBysCache[viewAsPublisherId] = data.data.groupBys;
        }
        else {
          groupBysCache.admin = data.data.groupBys;
        }
        deferred.resolve(data.data.groupBys);
      })

        .catch(function (err) {
          deferred.reject(err);
        });

    } else {
      let cachedGroupBys;
      if (viewAsBuyerId) {
        cachedGroupBys = groupBysCache[viewAsBuyerId];
      }
      else if (viewAsPublisherId) {
        cachedGroupBys = groupBysCache[viewAsPublisherId];
      }
      else {
        cachedGroupBys = groupBysCache.admin;
      }
      deferred.resolve(cachedGroupBys);
    }

    return deferred.promise.then(function (response) {
      return _.map(response, function(groupBy) {
        groupBy.displayName = transformDisplayName(groupBy.displayName);
        return groupBy;
      });
    });
  }

  function clearGroupBysCache() {
    groupBysCache = {};
  }

  function getMessageNamesFromColumns(events) {
    return _.map(events, function (e) {
      const eventName = _.findKey(nameMap, function (value) {
        return value === e;
      });
      return eventName;
    });
  }

  function parseGroupData(groupData,utcOffset,isAffiliate) {
    isAffiliate =  isAffiliate || accountsService.isAffiliate();
    const isBuyer = accountsService.isBuyer();

    //TODO: This is getting really ugly parsing the
    //Elasticsearch Results client side, I will be moving this logic
    //server side as sending down a more uniform aggregation data
    const result = {
      rows: [],
      totals: {
        calls: 0,
        connected: 0,
        converted: 0,
        qualified: 0,
        completed: 0,
        noTarget: 0,
        noConnect: 0,
        errorCall: 0,
        noAnswer: 0,
        blocked: 0,
        payout: 0,
        amount: 0,
        pc: 0,
        rpc: 0,
        acl: 0,
        tm: 0,
        TC: 0
      }
    };
    let items = [];
    let noIncoming = false;
    items = _getChild(groupData, ['items']);

    if (!items) {
      items = _getChild(groupData, ['aggregations', 'filter', 'aggregations', 'nest', 'items']);
      if (items) {
        noIncoming = true;
      } else {
        items = _getChild(groupData, ['aggregations', 'tag-filter', 'aggregations', 'tag-values', 'items']);
        if (!items) {
          const buckets = _getChild(groupData, ['aggregations']);
          if (buckets) {
            items = [];
            _.forEach(buckets, function (value, key) {
              items.push({
                aggregations: value.aggregations,
                docCount: value.docCount,
                key: key
              });
            });
          }

        }
      }
    }
    _.forEach(items, function (item) {
      let row = {};
      row.name = _getKeyFromItem(item, utcOffset);
      row.calls = noIncoming ? 0 : item.docCount;
      row.payout = 0;
      result.totals.calls += row.calls;
      result.totals.payout += row.payout;
      let baseAggregations = _getChild(item, ['aggregations', 'rn', 'aggregations', 'events', 'aggregations', 'filter', 'aggregations']);
      if (!baseAggregations) {
        baseAggregations = _getChild(item, ['aggregations', 'events', 'aggregations', 'filter', 'aggregations']);
        if (!baseAggregations) {
          baseAggregations = _getChild(item, ['aggregations']);
        }
      }


      _setRowCost(baseAggregations, item, row, result.totals);
      if (baseAggregations) {

        _getCallLengthStats(baseAggregations, row, result.totals);
        _getConversionStats(baseAggregations, row, result.totals, isAffiliate);
        _getEventCounts(baseAggregations, row, result.totals);
        if (noIncoming) {
          row.calls = row.connected;
          result.totals.calls += row.calls;
        }
        _getComputedRows(row, result.totals, isAffiliate, isBuyer);

      } else {
        row = _setRowToZeros(row);
      }

      result.rows.push(row);

    });
    _computeTotals(result);
    return result;
  }

  function transformDisplayName(displayName) {
    const transformationMap = {
      'Conversion Amount': 'Revenue',
      'Affiliate': 'Publisher',
      'Target Name': 'Target'
    };
    return Object.hasOwn(transformationMap, displayName.trim()) ? transformationMap[displayName] : displayName;
  }

  function _appendBuyerAndPublisherId(url, viewAsPublisherId, viewAsBuyerId) {
    // use a url package to manage url and querystring params
    const queryStringPrefix = url.indexOf('?') > -1 ? '&' : '?';
    let returnValue = url;
    if (viewAsPublisherId) {
      returnValue += queryStringPrefix + 'affid=' + viewAsPublisherId;
    }
    if (viewAsBuyerId) {
      returnValue += (viewAsPublisherId ? '&' : queryStringPrefix) + 'byid=' + viewAsBuyerId;
    }
    return returnValue;
  }

  function _getKeyFromItem(item,utcOffset) {


    if (item.date) {
      return moment(item.key).utc().utcOffset(utcOffset).format('MMM DD');
    } else {
      return item.key;
    }
  }

  function _getChild(obj, path) {
    return utils.getChildObject(obj, path);
  }


  function _computeTotals(result) {
    result.totals.rpc = result.totals.calls > 0 ? result.totals.amount / result.totals.calls : 0;
    result.totals.acl = result.totals.completed > 0 ? result.totals.tm / result.totals.completed : 0;
    result.totals.pc = result.totals.calls > 0 ? result.totals.converted / result.totals.calls : 0;
  }

  function _getComputedRows(row, totals, isAffiliate, isBuyer) {
    if (isAffiliate) {
      row.pc = row.calls > 0 ? row.qualified / row.calls : 0;
      row.rpc = row.calls > 0 ? row.payout / row.calls : 0;
    } else {
      row.pc = row.calls > 0 ? row.converted / row.calls : 0;
      row.rpc = row.calls > 0 ? row.amount / row.calls : 0;
    }

    if (!isAffiliate && !isBuyer) {
      row.profit = row.amount - row.payout;

      if (typeof totals.profit != 'number') {
        totals.profit = row.profit;
      } else {
        totals.profit += row.profit;
      }
    }

    totals.pc += row.pc;
    totals.rpc += row.rpc;
  }

  function _getEventCounts(ba, row, totals) {
    row.connected = 0;
    row.converted = 0;
    row.qualified = 0;
    row.completed = 0;
    row.noTarget = 0;
    row.noConnect = 0;
    row.noAnswer = 0;
    row.blocked = 0;
    if (ba.name) {

      _.forEach(ba.name.items, function (ev) {
        if (nameMap[ev.key]) {
          row[nameMap[ev.key]] = ev.docCount;
          totals[nameMap[ev.key]] += ev.docCount;
        }
      });
    }
  }

  function _setRowToZeros(row) {
    row.connected = 0;
    row.converted = 0;
    row.qualified = 0;
    row.completed = 0;
    row.noTarget = 0;
    row.noConnect = 0;
    row.noAnswer = 0;
    row.amount = 0;
    row.blocked = 0;
    row.pc = 0;
    row.rpc = 0;
    row.acl = 0;
    row.tm = 0;
    row.TC = 0;

  }

  function _getConversionStats(ba, row, total) {
    const caAg = _getChild(ba, ['convertedCall', 'aggregations', 'evVals', 'aggregations', 'conversionAmount', 'aggregations']);
    if (caAg) {
      row.amount = caAg.totalConversion.value;
      total.amount += row.amount;
    } else {
      row.amount = 0;
    }

    const paAg = _getChild(ba, ['convertedCall', 'aggregations', 'evVals', 'aggregations', 'payoutAmount', 'aggregations']);
    if (paAg) {
      row.payout = paAg.totalPayout.value;
      total.payout += row.payout;
    } else {
      row.payout = 0;
    }

    //this is for the new payout version
    const paAg2 = _getChild(ba, ['payoutCall', 'aggregations', 'evVals', 'aggregations', 'payoutAmount', 'aggregations']);
    if (paAg2) {
      row.payout += paAg2.totalPayout.value;
      total.payout += paAg2.totalPayout.value;
    }
  }

  function _setRowCost(ba, item, row, totals) {
    row.TC = _getChild(item, ['aggregations', 'inboundCost', 'value']) || _getChild(item, ['aggregations', 'rn', 'aggregations', 'inboundCost', 'value']) || 0.0;
    row.TC += _getChild(ba, ['eventCosts', 'aggregations', 'eventCostsFiltered', 'aggregations','eventSums', 'aggregations', 'amount', 'value'] ) ||
              _getChild(ba, ['eventCosts', 'aggregations', 'eventSums', 'aggregations', 'amount', 'value'] ) || 0;
    totals.TC += row.TC;
  }

  function _getCallLengthStats(ba, row, total) {
    if (ba.completedCall) {
      const clAg = ba.completedCall
        .aggregations.evVals
        .aggregations.callLengthInSeconds
        .aggregations;

      row.acl = clAg.avgTime.value;
      row.tm = clAg.totalTile.value;
      total.acl += row.acl;
      total.tm += row.tm;
    } else {
      row.acl = 0;
      row.tm = 0;
    }
    return row;
  }

}
